import Projects from "../../components/Project/Projects";

export default function BuyerProjects() {
  return (
    <Projects userRole={"Buyer"} />
  );
}